/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Error_Weak_PasswordInputs */

const en_login_error_weak_password = /** @type {(inputs: Login_Error_Weak_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please choose a stronger password.`)
};

const fr_login_error_weak_password = /** @type {(inputs: Login_Error_Weak_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez choisir un mot de passe plus fort.`)
};

const de_login_error_weak_password = /** @type {(inputs: Login_Error_Weak_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte wählen Sie ein sichereres Passwort.`)
};

const it_login_error_weak_password = /** @type {(inputs: Login_Error_Weak_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scegli una password più sicura.`)
};

const ru_login_error_weak_password = /** @type {(inputs: Login_Error_Weak_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пожалуйста, выберите более надежный пароль.`)
};

const es_login_error_weak_password = /** @type {(inputs: Login_Error_Weak_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elija una contraseña más segura.`)
};

const zh_cn2_login_error_weak_password = /** @type {(inputs: Login_Error_Weak_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请选择更强的密码。`)
};

const ja_login_error_weak_password = /** @type {(inputs: Login_Error_Weak_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`より強力なパスワードを選択してください。`)
};

const hi_login_error_weak_password = /** @type {(inputs: Login_Error_Weak_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कृपया अधिक मजबूत पासवर्ड चुनें।`)
};

const pt_pt2_login_error_weak_password = /** @type {(inputs: Login_Error_Weak_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor, escolha uma senha mais forte.`)
};

/**
* | output |
* | --- |
* | "Please choose a stronger password." |
*
* @param {Login_Error_Weak_PasswordInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_error_weak_password = /** @type {((inputs?: Login_Error_Weak_PasswordInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Error_Weak_PasswordInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_login_error_weak_password(inputs)
	if (locale === "de") return de_login_error_weak_password(inputs)
	if (locale === "it") return it_login_error_weak_password(inputs)
	if (locale === "ru") return ru_login_error_weak_password(inputs)
	if (locale === "es") return es_login_error_weak_password(inputs)
	if (locale === "zh-CN") return zh_cn2_login_error_weak_password(inputs)
	if (locale === "ja") return ja_login_error_weak_password(inputs)
	if (locale === "hi") return hi_login_error_weak_password(inputs)
	if (locale === "pt-PT") return pt_pt2_login_error_weak_password(inputs)
	return en_login_error_weak_password(inputs)
});